export enum AccessCodeType {
	Autogenerated = 1,
	Custom = 2,
}
